module.exports = __webpack_public_path__ + "img/2e7c723c9574a8ef2e8ffb0370824190.png";